import React from "react";
import PdfPage from "../components/PdfPage";
import "./index.css";
import policyImg from "../assets/images/policy.jpg";
const Policies = () => {
  return (
    <main className="pdf-modern-page">
      <PdfPage
        h1={"Policies & Procedures"}
        // h2={"KNOW YOUR CUSTOMER & CUSTOMER DUE DILIGENCE"}
        img={policyImg}
        pdf1={"https://api.orbitsecurities.com.pk/media/cms/documents/aml-compliance-policy.pdf"}
        pdf1Text={"Compliance Policy"}
        pdf2={
          "https://api.orbitsecurities.com.pk/media/cms/documents/online-trading-policy.pdf"
        }
        pdf2Text={"Online Trading Policy"}
      />
      <PdfPage
        h1={"Risk Management Policy"}
        // h2={"Risk Management Policy"}
        img={policyImg}
        pdf1={"https://api.orbitsecurities.com.pk/media/cms/documents/risk-management-policy.pdf"}
        pdf1Text={"Compliance Policy"}
        pdf2={"https://api.orbitsecurities.com.pk/media/cms/documents/online-trading-risk-policy.pdf"}
        pdf2Text={"Online Trading Risk Policy"}
      />
    </main>
  );
};

export default Policies;
